// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__28yAU","inputWrap":"CustomTip_inputWrap__18fIl"};